import {Component, Inject, OnDestroy, OnInit, signal, WritableSignal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {JointjsPlusComponent} from "../../jointjs-plus/jointjs-plus.component";
import {MatButton, MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {MatList, MatListItem} from "@angular/material/list";
import {MatDivider} from "@angular/material/divider";
import {NgOptimizedImage} from "@angular/common";
import {Subscription, timer} from "rxjs";

@Component({
  selector: 'app-jointjs-modal',
  standalone: true,
  imports: [
    JointjsPlusComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIconModule,
    MatProgressSpinner,
    MatSlideToggle,
    ReactiveFormsModule,
    MatMiniFabButton,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatList,
    MatListItem,
    MatDivider,
    NgOptimizedImage
  ],
  templateUrl: './jointjs-modal.component.html',
  styleUrl: './jointjs-modal.component.scss'
})
export class JointjsModalComponent implements OnInit, OnDestroy {
  logigramme: any;
  procedureTitre: string;
  procedureMnemonique: string;
  idEditMode: boolean;
  modeEdition!: FormControl<boolean>;
  private timerSubscription: Subscription | undefined;

  isLogigrammeBeingSaved: WritableSignal<boolean>;

  constructor(public dialogRef: MatDialogRef<JointjsModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isLogigrammeBeingSaved = signal(false);
    this.logigramme = data.logigramme;
    this.procedureTitre = data.procedureTitre;
    this.procedureMnemonique = data.procedureMnemonique;
    this.idEditMode = data.idEditMode;
    this.modeEdition = new FormControl(true, {
      nonNullable: true
    });
    if (this.data.logigramme && Object.keys(this.data.logigramme).length > 0) {
      this.logigramme = this.data.logigramme;
    } else {
      this.logigramme = {}
    }
  }
  ngOnInit(): void {
    //On lance le timer à l'ouverture de la modal du logigramme
    this.timerSubscription = timer(0, 60000).subscribe(() => {
        //Chaque 1 min, on sauvegarde le logigramme dans le sessionStorage
        this.setSessionStorage();
      })
  }

  setSessionStorage() {
    sessionStorage.setItem(this.procedureMnemonique, JSON.stringify(this.logigramme));   
  }

  onGraphChanged(logigramme: any) {
    this.logigramme = logigramme;
  }

  closeDialog(closeDialog: boolean) {
    if (closeDialog) {
      this.dialogRef.close(this.logigramme);
    }
  }

  sendLogigramme() {
    // A chaque fermeture de la modal, on sauvegarde le logigramme dans le sessionStorage
    this.setSessionStorage();
    this.dialogRef.close(this.logigramme);
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
